import React from 'react'

const LocationPermissionIcon = () => {
    return (
        <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M52.9187 19.3625C49.3843 15.7672 44.6921 14 39.9999 14C35.3077 14 30.6155 15.7672 27.0812 19.3625C19.9515 26.4922 19.9515 38.0703 27.0812 45.2L39.9999 57.875L52.9187 45.2C60.0483 38.0703 60.0483 26.4922 52.9187 19.3625Z" fill="#99A3AB" fillOpacity="0.5" />
            <path d="M39.9999 38.8016C43.7019 38.8016 46.703 35.8005 46.703 32.0984C46.703 28.3964 43.7019 25.3953 39.9999 25.3953C36.2978 25.3953 33.2968 28.3964 33.2968 32.0984C33.2968 35.8005 36.2978 38.8016 39.9999 38.8016Z" fill="white" />
            <path d="M18.9999 16.3245L55.5134 52.8379L56.8066 51.5447L20.2932 15.0312C20.4933 16.0849 20.0536 16.5246 18.9999 16.3245Z" fill="#99A3AB" />
            <ellipse cx="38.5" cy="61.5312" rx="16.5" ry="1.5" fill="#99A3AB" fillOpacity="0.4" />
        </svg>

    )
}

export default LocationPermissionIcon